import { Col, Row, Modal } from 'antd';
import { useState } from 'react';
import CustomButton from '../../../../../v2-components/Antd/Button';
import CustomDivider from '../../../../../v2-components/Antd/Divider';
import CustomModal from '../../../../../v2-components/Antd/Modal';
import './style.scss';
import { useHistory } from 'react-router-dom';
import { Service } from '../../../service';


export default function StatusCard(props) {
	const [openConfirm, setOpenConfirm] = useState(false);
	const [isApproving, setIsApproving] = useState(false);
	const history = useHistory();

	const preorderData = props?.quotationData;
	const status = preorderData?.status; // PAYMENT_PENDING or PAYMENT_APPROVED
	const pharmacy = preorderData?.purchase_detail?.info?.pharmacy?.[0]?.pharmacy || preorderData?.purchase_detail?.root_pharmacy || 'narma';
	const trx_id = preorderData?.trx_id || '-';
	const token = props?.token;
	const onApprovalSuccess = props?.onApprovalSuccess;

	const paymentTrackingId = preorderData?.payment_tracking_detail?._id;

	const handleApprove = async () => {
		if (!paymentTrackingId || !token) {
			console.error('Missing paymentTrackingId or token');
			return;
		}

		setIsApproving(true);
		try {
			const response = await new Service().changeStatusPreorder(paymentTrackingId, 'approved', token);
			if (response && !response.error) {
				
				setOpenConfirm(false);
				// Refetch data
				if (onApprovalSuccess) {
					onApprovalSuccess();
				}
			} else {
				console.error('Error al aprobar la pre-orden:', response?.error);
			}
		} catch (error) {
			console.error('Error al aprobar la pre-orden:', error);
		} finally {
			setIsApproving(false);
		}
	};

	const handleNext = () => {
		// Validar que se haya visto el comprobante de pago
		if (!props?.voucherViewed) {
			Modal.error({
				title: 'Validación requerida',
				width: 500,
				content: (
					<div style={{ marginTop: '10px' }}>
						<p>Para poder aprobar la pre-orden, primero debes:</p>
						<ul style={{ color: '#ff4d4f', paddingLeft: '20px', marginTop: '10px' }}>
							<li>Revisar el comprobante de pago haciendo clic en "Comprobante de pago" en la sección de Pago</li>
							<li>Verificar que el monto coincida con el total de la pre-orden</li>
						</ul>
					</div>
				),
			});
			return;
		}
		setOpenConfirm(true);
	};

	return (
		<div className="status-card-container"> 
			<Row>
				<Col span={24}>
					<h3>Estado de la pre-orden</h3>
					<span>
						{status === 'PAYMENT_PENDING' && 'Pre-orden por aprobar'}
						{status === 'PAYMENT_APPROVED' && 'Pre-orden pagada'}
						{status === 'PAYMENT_REJECTED' && 'Pre-orden rechazada'}
					</span>
				</Col>
				{status === 'PAYMENT_PENDING' && (
					<>
						<p>Antes de aprobar la pre-orden y continuar, verifica que el comprobante de pago coincida con el monto a abonar.</p>
					</>
				)}
				{status === 'PAYMENT_APPROVED' && (
					<Col span={24}>
						<p>Has validado el comprobante y se le ha enviado al paciente el detalle de la orden para hacer seguimiento.</p>
					</Col>
				)}
			</Row>
			<Row justify={'center'}>
				<Col>
					<CustomButton 
						style={{ 
							opacity: status === 'PAYMENT_PENDING' ? 1 : 0, 
							backgroundColor: '#088926', 
							color: '#FFFFFF', 
							marginLeft: '30px' 
						}} 
						onClick={handleNext} 
						disabled={status !== 'PAYMENT_PENDING'}
					>
						Aprobar
					</CustomButton>
				</Col>
				<Col>
					<CustomButton 
						style={{ 
							opacity: status === 'PAYMENT_APPROVED' ? 1 : 0, 
							backgroundColor: '#686e6a', 
							color: '#FFFFFF', 
							marginLeft: '30px' 
						}} 
						onClick={() => history.push(`/v2/tracking/detail/${pharmacy}/${trx_id}`)} 
						disabled={status !== 'PAYMENT_APPROVED'}
					>
						Ver orden
					</CustomButton>
				</Col>
			</Row>

			<CustomModal onCancel={() => setOpenConfirm(false)} footer={null} open={openConfirm}>
				<h2>Avanzar</h2>
				<CustomDivider />
				<h5>Al darle a continuar estás confirmando que el estado está completo</h5>
				<p>Si estás de acuerdo dale a continuar</p>
				<CustomDivider />
				<div className="button-container">
				<CustomButton onClick={() => setOpenConfirm(false)} disabled={isApproving}>Cancelar</CustomButton>
				<CustomButton onClick={handleApprove} style={{ backgroundColor: '#088926', color: '#FFFFFF', marginLeft: '10px' }} loading={isApproving} disabled={isApproving}>Continuar</CustomButton>
				</div>
			</CustomModal>
		</div>
	);
}
